export const welfareCategories = [
  'Lost Child',
  'Found Child',
  'Vulnerable Person Support',
  'Safeguarding Alert (External)',
  'Lost Property',
  'Found Property',
  'Welfare Check',
  'Other',
]

export const welfareOutcomes = [
  'Reunited with Parent / Guardian',
  'Handed to Event Safeguarding Team',
  'Handed to Police / Security',
  'Referred to Safeguarding',
  'Property Returned to Owner',
  'Property Handed to Event Control',
  'Resolved - No Further Action',
  'Other',
]
